<template>
  <Admin>
    <v-main>
      <v-container fluid>
        <v-row justify="center">
          <v-col>
            <document-table :data="displayedItems"></document-table>
          </v-col>
        </v-row>
        <v-row justify="start" class="tw-my-4">
          <v-col>
            <select class="items-per-page-selector" v-model="itemsPerPage">
              <option
                v-for="option in itemsPerPageOptions"
                :key="option"
                :value="option"
                :selected="option === itemsPerPage"
              >
                {{ option }}
              </option>
            </select>
          </v-col>
          <v-col>
            <v-pagination
              v-model="currentPage"
              :length="numPages"
              :total-visible="10"
              @input="paginate"
            ></v-pagination>
          </v-col>
          <v-col class="tw-flex tw-items-end tw-justify-end">
            <p class="total-item">จำนวนเอกสารทั้งหมด: {{ totalItems }}</p>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Admin from "../../components/admin/admin-main-template";
import DocumentTable from "../../components/admin/documents/table.wht.vue";

export default {
  name: "WithHoldingTax",
  components: {
    Admin,
    DocumentTable,
    // PaginationWithKeyword,
  },
  data() {
    return {
      itemsPerPage: 10,
      currentPage: 1,
      displayedItems: [],
      itemsPerPageOptions: [10, 20, 30, 40, 50],
    };
  },
  computed: {
    ...mapState({
      docs: (state) => state.thaismartTax.list,
      keyword: (state) => state.thaismartTax.keyword,
      // summaryAll: (state) => state.thaismartTax.summaryAll,
    }),
    numPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    totalItems() {
      return this.docs.length;
    },
  },
  methods: {
    ...mapActions({
      resetKeyword: "thaismartTax/resetKeyword",
      setSelectedList: "thaismartTax/setSelectedList",
    }),
    paginate() {
      //console.log("this is current page" ,this.currentPage)
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      // 0010 remove padding
      const endIndex = Number.parseInt(startIndex) +  Number.parseInt(this.itemsPerPage);
      // const endIndex = startIndex + this.itemsPerPage;

      //console.log(startIndex)
      //console.log(endIndex)

      if (startIndex != 0 && startIndex >= this.docs.length) {
          // Reset to page 1 if the current page is out of range
          console.warn("Page exceeds available data. Resetting to page 1");
          this.currentPage = 1;
          this.paginate();  // Re-run pagination for page 1
      } else {
          // If the page is within range, slice the items as usual
          this.displayedItems = this.docs.slice(startIndex, endIndex);
      }
      // debugger;
      // console.log("displayedItems", this.displayedItems.length);
    },
  },
  beforeRouteLeave(to, from, next) {
    // console.log("current", from.path, '->', to.path);
    this.resetKeyword();
    this.setSelectedList({ selectedList: [] });
    next();
  },
  watch: {
    docs: {
      handler() {
        this.paginate();
      },
      immediate: true,
    },
    itemsPerPage() {
      this.paginate();
    },
    currentPage() {
      this.paginate();
    },
  },
  mounted() {
    this.itemsPerPage = Number.isNaN(Number.parseInt(localStorage.getItem("pageLimit"))) ? 10 : Number.parseInt(localStorage.getItem("pageLimit"));
  },
};
</script>
<style scoped   >
.items-per-page-selector {
  padding: 0.3rem .5rem;
  border: 1px solid #ccc;
  border-radius: 5px;
}
</style>
